import type { ComposerElement } from '../../../../../../../../types/pageEditor';
import FormGroup from '../../../../../../../generic/FormGroup';
import { COMPONENT_CONFIGURATION_LABELS } from '../../../../../../constants';
import ConfigSection from '../../ConfigSection';

interface Props {
    componentConfigOptions: { [key: string]: boolean };
    modifierValues: Partial<ComposerElement>;
    updateHelpInfo: (helpInfo: string) => void;
    updateHintValue: (hitValue: string) => void;
}

const HelpSection = ({
    componentConfigOptions,
    modifierValues,
    updateHelpInfo,
    updateHintValue,
}: Props) => {
    if (!(componentConfigOptions || modifierValues)) {
        return null;
    }

    const { hasHintValue } = componentConfigOptions ?? {};
    const { helpInfo, hintValue } = modifierValues;

    return (
        <ConfigSection dataTestId="help-section">
            {hasHintValue && (
                <FormGroup
                    label={COMPONENT_CONFIGURATION_LABELS['HINT_VALUE']}
                    htmlFor="component-hint-value"
                >
                    <input
                        className="form-control"
                        id="component-hint-value"
                        type="text"
                        value={hintValue || ''}
                        onChange={(event) => {
                            updateHintValue(event.target.value);
                        }}
                    />
                </FormGroup>
            )}

            <FormGroup
                label={COMPONENT_CONFIGURATION_LABELS['HELP_INFO']}
                htmlFor="component-help-info"
            >
                <textarea
                    className="form-control"
                    id="component-help-info"
                    value={helpInfo || ''}
                    onChange={(event) => {
                        updateHelpInfo(event.target.value);
                    }}
                />
            </FormGroup>
        </ConfigSection>
    );
};

export default HelpSection;
